import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) { toast.error(apiError(err, t)); } finally { setLoading(false); }
  };

  return (
    <div className="relative mx-auto flex min-h-screen max-w-md flex-col bg-[#F8FAF8]">
      <div className="flex justify-end p-4"><LanguageSwitcher /></div>
      <div className="flex flex-1 flex-col justify-center px-6 pb-16">
        <button data-testid="forgot-back" onClick={() => navigate("/login")} className="mb-4 flex items-center gap-1 text-sm font-semibold text-[#2D5A4C]">
          <ArrowLeft size={16} /> {t("reset.back")}
        </button>
        <div className="rounded-3xl border border-[#E2EAE5] bg-white p-6 shadow-sm">
          <h1 className="mb-1 font-display text-2xl font-extrabold text-[#1A2E26]">{t("reset.title")}</h1>
          {sent ? (
            <p data-testid="forgot-sent" className="mt-3 rounded-xl bg-[#EDF7F2] p-3 text-sm text-[#1B6943]">{t("reset.sent")}</p>
          ) : (
            <form onSubmit={submit} className="mt-4 space-y-3">
              <p className="text-sm text-[#7A9488]">{t("reset.desc")}</p>
              <div className="relative">
                <Mail size={18} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#7A9488]" />
                <Input data-testid="forgot-email-input" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder={t("auth.email")} className="h-12 rounded-xl pl-10" />
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={loading}
                className="h-12 w-full rounded-xl bg-[#2D5A4C] text-base font-semibold hover:bg-[#214439]">
                {loading ? "…" : t("reset.send")}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
